import React, {useContext, useState} from 'react';

import {AppContext} from '../../AppModule/Context';

import AnimatedLogoComponent from '../common/genericComponents/animatedLogoComponent';
import ErrorComponent from '../common/genericComponents/redesign/inputComponentV2/components/errorComponent/errorComponent';
import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import ImagePreviewComponent from '../common/genericComponents/redesign/imagePreviewComponent/imagePreviewComponent';
import ProgressBarComponent from '../common/genericComponents/redesign/progressBarComponent/progressBarComponent';

import FileSharingService from '../../services/restServices/FileSharingService';
import ImageSharingService from '../../services/restServices/ImageSharingService';
import threedService from '../../services/restServices/threedService';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';
import fileIconImage from '../../assets/svg/file-icon-in-chat.svg';

import './sendFileComponent.css';

const SendFileComponent = (props) => {
  const context = useContext(AppContext);

  const [isUploading, setIsUploading] = useState(false);
  const [previewImgUrl, setPreviewImgUrl] = useState(null);
  const [progressOfUploading, setProgressOfUploading] = useState(0);

  const [fileUploadCancelToken, setFileUploadCancelToken] = useState(null);
  const inputFileRef = React.useRef();
  const imageRef = React.useRef();

  const isFileSizeOk = () =>
    props.currentSelectedFile &&
    Number((props.currentSelectedFile.size / 1024 / 1024).toFixed(2)) <=
      (props.threed
        ? VIDABOO_CONSTANTS.MAX_THREED_SIZE_IN_MB
        : VIDABOO_CONSTANTS.MAX_FILE_SIZE_IN_MB);

  React.useEffect(() => {
    if (isImage() && isFileSizeOk()) getFileSrc();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.currentSelectedFile]);
  const getFileSrc = () => {
    let fr = new FileReader();
    fr.onload = () => {
      imageRef.current.src = fr.result;
      imageRef.current.hidden = false;
    };
    fr.readAsDataURL(props.currentSelectedFile);
  };

  const isImage = () =>
    props.currentSelectedFile &&
    props.currentSelectedFile.type.includes('image');

  const handleClose = () => {
    if (fileUploadCancelToken) {
      fileUploadCancelToken.cancel();
      setFileUploadCancelToken(null);
    }
    setIsUploading(false);
    setProgressOfUploading(0);
    props.handleClose();
  };
  const handleSendFile = () => {
    const currentSelectedFile = props.currentSelectedFile;
    if (!currentSelectedFile) return;
    const fr = new FileReader();
    fr.readAsDataURL(currentSelectedFile);
    fr.onload = async () => {
      if (isImage()) {
        setIsUploading(true);
        const response = await ImageSharingService.saveImageMessageByChatRoomId(
          props.senderObjectType,
          props.senderObjectId,
          props.roomId,
          fr.result,

          (cancelToken) => setFileUploadCancelToken(cancelToken),
          (progress) => {
            setProgressOfUploading(progress);
          },
        );
        if (response.status === 200) {
          const toastObj = utilsService.getToastObj({
            toastTitle: 'File sent',
            toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
          });
          context.addToastObj(toastObj);
          props.sendMessage(
            'Image Transfer',
            currentSelectedFile.type.includes('image')
              ? VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE
              : VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE,
            JSON.stringify({
              mediaMessageId: response.data.mmDto.mediaMessageId,
              fileSize: currentSelectedFile.size,
              fileName: currentSelectedFile.name,
              fileType: currentSelectedFile.type,
            }),
          );
        } else {
          const toastObj = utilsService.getToastObj({
            toastTitle: 'Failed to send file',
            toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
          });
          context.addToastObj(toastObj);
        }
        props.handleClose();
      } else {
        const response = await FileSharingService.saveFileMessageByChatRoomId(
          props.senderObjectType,
          props.senderObjectId,
          props.roomId,
        );
        setIsUploading(true);
        const s3Response = await FileSharingService.uploadFileToS3(
          fr.result,
          response.data.tempAccessibleUrl,
          (progress) => {
            setProgressOfUploading(progress);
          },
          (cancelToken) => setFileUploadCancelToken(cancelToken),
        );
        if (!s3Response) {
          const toastObj = utilsService.getToastObj({
            toastTitle: 'Failed to send file',
            toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
          });
          context.addToastObj(toastObj);
          props.handleClose();
          return;
        }
        const savedConfirmedResponse =
          await FileSharingService.saveConfirmedFile(
            response.data.mediaMessageId,
            s3Response,
            currentSelectedFile.name,
            currentSelectedFile.size,
            currentSelectedFile.type.split('/')[1],
          );

        // now send message
        props.sendMessage(
          'File Transfer',
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE,
          JSON.stringify({
            mediaMessageId: savedConfirmedResponse.data.mediaMessageId,
            fileSize: currentSelectedFile.size,
            fileName: currentSelectedFile.name,
            fileType: currentSelectedFile.type,
          }),
        );
        const toastObj = utilsService.getToastObj({
          toastTitle: 'File sent',
          toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
        });
        context.addToastObj(toastObj);
        props.handleClose();
      }

      props.onFileSelected(null);
      setIsUploading(false);
      setProgressOfUploading(0);
    };
  };
  const handleSend3DFile = () => {
    const currentSelectedFile = props.currentSelectedFile;
    let objectId = props.currentUser.userId;
    let objectType = 'PERSONAL';
    if (props.accountDto && props.accountDto.isActive) {
      objectId = props.accountDto.accountId;
      objectType = 'ACCOUNT';
    }
    if (!currentSelectedFile) return;
    const fr = new FileReader();
    fr.readAsDataURL(currentSelectedFile);
    fr.onload = async () => {
      setIsUploading(true);
      const fileName = currentSelectedFile.name;
      const splitFileName = fileName.split('.');
      const response = await threedService.createThreeD({
        fileName,
        size: currentSelectedFile.size,
        title: splitFileName[0].toUpperCase(),
        objectId,
        objectType,
      });

      if (response) {
        const s3Response = await threedService.uploadFileToS3(
          currentSelectedFile,
          response.threedFileDto.tempThreedFileUploadUrl,
          (progress) => {
            if (progress === '100.00') {
              setProgressOfUploading('90.97');
            } else {
              setProgressOfUploading(progress);
            }
          },
          (cancelToken) => setFileUploadCancelToken(cancelToken),
        );

        if (!s3Response) {
          return;
        }
        setProgressOfUploading('100.00');

        const savedConfirmedResponse = await threedService.save3DConfirmed(
          response.threedFileDto.threedFileId,
        );
        if (savedConfirmedResponse) {
          props.handleClose();

          props.getAllFiles('newfile');
          props.onFileSelected(null);
          setIsUploading(false);
          setProgressOfUploading(0);
        }
      }
    };
  };

  const onFileClick = (previewImgUrl) => {
    setPreviewImgUrl(previewImgUrl);
  };

  const handleClosePreview = () => {
    setPreviewImgUrl(null);
  };

  return (
    <>
      {previewImgUrl && (
        <ImagePreviewComponent
          isFullScreen={true}
          src={previewImgUrl}
          onClose={handleClosePreview}
        />
      )}
      <div
        className={`et-v2-send-file-container ${
          previewImgUrl ? 'et-v2-send-file-container-hidden' : ''
        } ${
          utilsService.getIsClient() ? 'et-v2-send-file-container-small' : ''
        }`}>
        <FormComponentV2
          isRightBtnDisabled={isUploading || !isFileSizeOk()}
          showRightBtnSpinner={isUploading}
          formTitle={props.headingText}
          leftBtnTxt={isUploading ? 'Cancel' : 'Close'}
          rightBtnTxt={props.threed ? 'Upload' : 'Send'}
          onLeftBtnClicked={handleClose}
          onRightBtnClicked={props.threed ? handleSend3DFile : handleSendFile}>
          <div
            className="et-v2-send-file-content-wrap"
            onDrop={(e) => {
              e.preventDefault();
              if (e.dataTransfer.files.length > 0) {
                props.onFileSelected(e.dataTransfer.files[0]);
              }
            }}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onPaste={(event) => {
              var items = (
                event.clipboardData || event.originalEvent.clipboardData
              ).items;
              for (let index in items) {
                var item = items[index];
                if (item.kind === 'file') {
                  var blob = item.getAsFile();
                  props.onFileSelected(blob);
                }
              }
            }}>
            {isUploading ? (
              <div className="et-v2-sfc-send-progress-wrapper">
                <div className="et-v2-sfc-file-send-animated-logo-wrapper">
                  <AnimatedLogoComponent />
                </div>
                <div className="et-v2-sfc-progress-bar-wrap">
                  <ProgressBarComponent
                    showBarTxtWhenFinished={progressOfUploading === '100.00'}
                    barText={props.threed ? 'Uploading' : 'Sending'}
                    percentage={progressOfUploading}
                  />
                </div>
              </div>
            ) : (
              <>
                {isFileSizeOk() || !props.currentSelectedFile ? (
                  <>
                    {!props.currentSelectedFile && (
                      <div className="et-v2-sfc-select-file-wrap">
                        <div
                          className="et-v2-sfc-select-file-txt"
                          onClick={() => {
                            if (!props.currentSelectedFile) {
                              inputFileRef.current.click();
                            }
                          }}>
                          Click to select a file
                        </div>
                        <div className="et-v2-sfc-drop-here-txt">
                          or drop here...
                        </div>
                      </div>
                    )}
                    {!isImage() && props.currentSelectedFile && (
                      <div className="et-v2-sfc-uploaded-file-wrap">
                        <img src={fileIconImage} alt="file" />
                        <div className="et-v2-sfc-send-file-name">
                          {props.currentSelectedFile.name}
                        </div>
                        <div className="et-v2-sfc-send-file-size">
                          {(props.currentSelectedFile.size / 1024).toFixed(2)}
                          kb.
                        </div>
                      </div>
                    )}
                    {isImage() && isFileSizeOk() && (
                      <div className="et-v2-sfc-uploaded-img-wrap">
                        <img
                          className="et-v2-sfc-uploaded-img"
                          ref={imageRef}
                          id="main"
                          alt="img"
                          onClick={() => {
                            if (!utilsService.getIsClient()) {
                              onFileClick(imageRef.current.src);
                            }
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <ErrorComponent
                    errorMessage={`Hey, that’s too large… Up to ${VIDABOO_CONSTANTS.MAX_FILE_SIZE_IN_MB}Mbs`}
                  />
                )}
              </>
            )}
            <input
              type="file"
              onChange={() => {
                props.onFileSelected(inputFileRef.current.files[0]);
              }}
              ref={inputFileRef}
              hidden
              accept={props.threed ? '.glb' : null}
            />
          </div>
        </FormComponentV2>
      </div>
    </>
  );
};

export default SendFileComponent;
